import {takeEvery,call,put,select} from "redux-saga/effects";
import {putMaterials} from "../Redux/material";
import Module from "../Classes/Module";
import * as THREE from 'three';
import {actionsState as modulesState} from "../Redux/modules";
import {actionsState as projectState} from "../Redux/project";
import {OBJLoader} from "three/examples/jsm/loaders/OBJLoader";
//import {ColladaLoader} from "three/examples/jsm/loaders/ColladaLoader";
import {GLTFLoader} from "three/examples/jsm/loaders/GLTFLoader";
import {FBXLoader} from "three/examples/jsm/loaders/FBXLoader";
import Plan from "../Classes/Plan";
import Node from "../Classes/Node";
import Link from "../Classes/Link";
import {useDispatch, useSelector} from "react-redux";
import {sendRedrawEvent, sendUnselectEvent} from "../Helpers/Events";

function* getData(){
    window.c3dLang = yield call(getTranslations);

    const modules = yield call(getModules);

    yield put(modulesState.getPrice());
    // console.log('modules',modules)
    yield put(modulesState.putAllModules(modules.sleepingModules));
    yield put(modulesState.putSections(modules.sections));
    const materials = yield call(getMaterials);
    window.materials = materials;

    // dispatch(projectState.addPreloader())


    // window.materials.wall.map(mat => {
    //     mat.side = THREE.DoubleSide
    // })
    yield put({
        type:putMaterials,
        value:{
            corpMaterials: materials.corp,
            activeCorpMaterial: materials.corp.length>0?materials.corp[0]:null,
            faceMaterials: materials.face,
            activeFaceMaterial: materials.face.length>0?materials.face[0]:null,
            clothMaterials: materials.cloth,
            activeClothMaterial: materials.cloth.length>0?materials.cloth[0]:null,
            floorMaterial: materials.floor,
            activeFloorMaterial: materials.floor.length>0?materials.floor[0]:null,
            wallMaterial: materials.wall,
            activeWallMaterial: materials.wall.length>0?materials.wall[0]:null,
            activeWallRMaterial: materials.wall.length>0?materials.wall[0]:null,
            activeWallLMaterial: materials.wall.length>0?materials.wall[0]:null,
        }});
    const match = window.location.search.match(/(hash)=([A-Z0-9]{8})/);
    //3957BF66
    if(match){
        const hash = match[2];
        const resp = yield loadProject(hash);

        yield put(projectState.setSaveResult({
            "status":"ok",
            "hash":hash,
            "href":""
        }));

        const plan = new Plan();
        resp.object.plan.nodes.map(n=>{
            plan.nodes.push(new Node(n.x,n.y));
        });
        resp.object.plan.links.map(l=>{
            const link = new Link(plan.nodes[l.a],plan.nodes[l.b]);
            link.h = l.h;
            link.height = l.height;
            link.leftSide = window.materials.wall.find(m=>m.userData.ID===l.leftSide);
            link.rightSide = window.materials.wall.find(m=>m.userData.ID===l.rightSide);
            link.objects = (l.objects) ? l.objects : []
            plan.links.push(link);
        });
        plan.calcGraphLoop();

        if (resp.object.plan.cycles) {
            plan.cycles.map((l,i)=>{
                const material = window.materials.floor.find(m=>m.userData.ID===resp.object.plan.cycles[i])
                if (material)
                    plan.cycles[i].material = material.clone()
            })
        }
        // console.log('plan',plan)
        if (resp.object.plan.offsetX) plan.offsetX = resp.object.plan.offsetX
        if (resp.object.plan.offsetY) plan.offsetY = resp.object.plan.offsetY
        if (resp.object.plan.zoom) plan.zoom = resp.object.plan.zoom
        if (resp.object.plan.ratio) plan.ratio = resp.object.plan.ratio
        if (resp.object.plan.canvasCenter) plan.canvasCenter = resp.object.plan.canvasCenter

        // const {devicePixelRatio: ratio=1} = window
        // console.log('ratio',ratio)
        // console.log('plan.ratio',plan.ratio)
        // plan.offsetX  = plan.offsetX * (ratio/plan.ratio)
        // plan.offsetY  = plan.offsetY * (ratio/plan.ratio)

        plan.restored = true
        // console.log('plan',plan)
        // console.log('resp.object',resp.object)
        yield put(projectState.setPlan(plan));
        /////////////////////////////////////////
        const modules = yield select(state=>state.modules.allModules);
        for(const mod of resp.object.objects){
            // console.log('function* getData(){ mod',mod);
            const shema = modules.find(m=>m.ID==mod.id);


            if (!shema) {
                console.error('_obj ERROR mod.id',mod.id)
            } else {
                const m = yield call(loadModule,shema);
                const corp = window.materials.corp.find(m=>m.userData.ID===mod.corp);
                const face = window.materials.face.find(m=>m.userData.ID===mod.face);
                const cloth = window.materials.cloth.find(m=>m.userData.ID===mod.cloth);
                m.corp = corp?corp.clone():window.materials.corp[0].clone();
                m.face = face?face.clone():window.materials.face[0].clone();
                m.cloth = cloth?cloth.clone():window.materials.cloth[0].clone();
                m.position = new THREE.Vector2(mod.position.x,mod.position.y);
                m.heightFromFloor = mod.heightFromFloor?mod.heightFromFloor:0;
                m.angle = mod.angle?mod.angle:0;
                m.optionStatus = mod.option?mod.option:false;
                yield put(modulesState.addInstanceModule(m));
            }
        }
        yield put(modulesState.getPrice());
    }
    yield put(projectState.decPreloader());
}
/**/
async function loadProject(hash){
    const resp = await fetch('/ajax/configurator3d.php', {
        method: 'POST',
        body: JSON.stringify({method:"loadProject",hash}),
        headers: {
            'Content-Type': 'application/json',
            'application':'x-www-form-urlencoded'
        }});
    return resp.json();
}
/**/
function* changeModule({module,variant}){
    yield put(projectState.addPreloader());
    const m = yield call(loadModule,variant);
    m.angle = module.angle;
    m.position = module.position.clone();
    m.optionStatus = module.optionStatus;
    if(variant.MATERIALS.corp===null || variant.MATERIALS.corp[module.corp.userData.ID]){
        m.corp = module.corp.clone();
    }
    if(variant.MATERIALS.face===null || variant.MATERIALS.face[module.face.userData.ID]){
        m.face = module.face.clone();
    }
    if(variant.MATERIALS.cloth===null || variant.MATERIALS.cloth[module.cloth.userData.ID]){
        m.cloth = module.cloth.clone();
    }
    const modules = yield select(store=>store.modules.modules);
    const newModules = modules.map(el=>{
        if(el===module) return m;
        else return el;
    });
    yield put(modulesState.putModules(newModules));
    yield put(modulesState.updateModule());
    yield put(modulesState.getPrice());
    yield put(projectState.decPreloader());
}
/**/
function* addModule(action){

    // console.log('function* addModule(action){')
    // console.log('action.refModule',action.refModule)

    yield put(projectState.addPreloader());
    const module = action.module;
    const m = yield call(loadModule,module);
    if (!action.refModule) {
        const activeCorpMaterial = yield select(store=>store.material.activeCorpMaterial);
        const activeFaceMaterial = yield select(store=>store.material.activeFaceMaterial);
        const activeClothMaterial = yield select(store=>store.material.activeClothMaterial);
        m.corp = activeCorpMaterial.clone();
        m.face = activeFaceMaterial.clone();
        m.cloth = activeClothMaterial.clone();
    } else {
        if (action.refModule.corp && typeof action.refModule.corp.clone === "function")
            m.corp = action.refModule.corp.clone();
        if (action.refModule.face && typeof action.refModule.face.clone === "function")
            m.face = action.refModule.face.clone();
        if (action.refModule.cloth && typeof action.refModule.cloth.clone === "function")
            m.cloth = action.refModule.cloth.clone();

        m._position = action.refModule._position.clone()
        m.position = action.refModule.position.clone()
        m.angle = action.refModule.angle
        m.heightFromFloor = action.refModule.heightFromFloor
        m.shema = {
            normal: action.refModule.shema.normal,
            hover: action.refModule.shema.hover
        }
    }
    // console.log('m',m)

    yield put(modulesState.addInstanceModule(m));
    yield put(modulesState.getPrice());
    yield put(projectState.decPreloader());
}
/* SAVE THE PROJECT */
const saveProject = function* (){
    yield put(projectState.addPreloader());
    // const hash = yield select(store=>store.project.saveResult.hash);
    const hash = '';
    const plan = yield select(store=>store.project.plan);
    const modules = yield select(store=>store.modules.modules);
    const price = yield select(store=>store.modules.price);
    const objects = modules.map(m=>({
        id:m.id,
        position: {x:m.position.x,y:m.position.y},
        heightFromFloor: m.heightFromFloor,
        angle:m.angle,
        corp:m.corp?m.corp.userData.ID:null,
        face:m.face?m.face.userData.ID:null,
        cloth:m.cloth?m.cloth.userData.ID:null,
        option:m.optionStatus,
        links: (m.optionStatus && m.option)?[m.option.ID]:[],
    }));
    // console.log('store.project',hash)
    const project = {
        hash: hash,
        price: price,
        plan: plan.toOBJ(),
        objects,
        stelage: [],
        kitchen: []
    }
    //console.log('project',project);
        //{"method":"saveProject","project":{"plan":{"points":[{"x":-200,"y":250},{"x":200,"y":250},{"x":200,"y":-250},{"x":-200,"y":-250}],"height":280,"floor":{"materialID":47557,"color":{"r":1,"g":1,"b":1}},"walls":{"materialID":47437,"color":{"r":1,"g":1,"b":1}},"wallObjects":[[],[],[],[]],"innerWalls":[]},"objects":[],"stelage":[],"kitchen":[]}}
    const resp = yield fetch('/ajax/configurator3d.php', {
        method: 'POST',
        body: JSON.stringify({method:"saveProject",project}),
        headers: {
            'Content-Type': 'application/json',
            'application':'x-www-form-urlencoded'
        }});
    const answer = yield resp.json();
    yield put(projectState.setSaveResult(answer));
    yield put(projectState.setModal('save'));
    // yield new Promise(res=>{
    //     setTimeout(()=>{res()},2000);
    // });
    yield put(projectState.decPreloader());
}
/**/
/* BUY THE PROJECT */
const buyProject = function* (){
    yield put(projectState.addPreloader());
    const hash = '';
    const plan = yield select(store=>store.project.plan);
    const modules = yield select(store=>store.modules.modules);
    const objects = modules.map(m=>({
        id:m.id,
        position: {x:m.position.x,y:m.position.y},
        heightFromFloor: m.heightFromFloor,
        angle:m.angle,
        corp:m.corp?m.corp.userData.ID:null,
        face:m.face?m.face.userData.ID:null,
        cloth:m.cloth?m.cloth.userData.ID:null,
        option:m.optionStatus,
        links: (m.optionStatus && m.option)?[m.option.ID]:[],
    }));
    // console.log('store.project',hash)
    const project = {
        hash: hash,
        plan: plan.toOBJ(),
        objects,
        stelage: [],
        kitchen: []
    }
    //console.log('project',project);
        //{"method":"saveProject","project":{"plan":{"points":[{"x":-200,"y":250},{"x":200,"y":250},{"x":200,"y":-250},{"x":-200,"y":-250}],"height":280,"floor":{"materialID":47557,"color":{"r":1,"g":1,"b":1}},"walls":{"materialID":47437,"color":{"r":1,"g":1,"b":1}},"wallObjects":[[],[],[],[]],"innerWalls":[]},"objects":[],"stelage":[],"kitchen":[]}}
    const resp = yield fetch('/ajax/configurator3d.php', {
        method: 'POST',
        body: JSON.stringify({method:"saveProject",project}),
        headers: {
            'Content-Type': 'application/json',
            'application':'x-www-form-urlencoded'
        }});
    const answer = yield resp.json();

    console.log('buyProject() answer',answer)
    window.location = 'https://olissys.com/configurator/order/addtocart.php?hash='+answer.hash;

    yield put(projectState.setSaveResult(answer));
    yield put(projectState.setModal('save'));
    yield put(projectState.decPreloader());
}
/**/
const dataSagaAsinc = function* (){
    yield takeEvery('getData',getData);
    yield takeEvery('MODULES/ADD_MODULE',addModule);
    yield takeEvery('SAVE_PROJECT',saveProject);
    yield takeEvery('BUY_PROJECT',buyProject);
    yield takeEvery('CHANGE_MODULE',changeModule);
    yield takeEvery('MODULES/GET_PRICE',getPrice);
};
/**/
function* getPrice(){
    const modules = yield select(store=>store.modules.modules);
    // console.log('getPrice() modules',modules)
    const query = modules.reduce((acc,mod)=>{
        const obj = {
            objID: mod.id,
            links: (mod.optionStatus && mod.option)?[mod.option.ID]:[],
            // links: [],
            faceMaterialID: (mod.face)?mod.face.userData.ID:null,
            corpMaterialID: (mod.corp)?mod.corp.userData.ID:null,
            clothMaterialID: (mod.face)?mod.face.userData.ID:null,
        }
        acc.push(obj);
        return acc
    },[]);
    const prices = yield getPriceAsync(query);
    // console.log('getPrice() => prices',prices)
    yield put(modulesState.setPrice(prices.price,prices.prices,prices.arAllPrices));
    // console.log('QUERY ',prices);
}
/**/
async function getPriceAsync(objects){
    const response = await fetch('/ajax/configurator3d.php', {
        method: 'POST',
        body: JSON.stringify({method:"getPrice",objects}),
        headers: {
            'Content-Type': 'application/json',
            'application':'x-www-form-urlencoded'
        }
    });
    return await response.json();
}
/**/
async function loadModule(_obj){

    let loader = null;
    if(/\.obj$/i.test(_obj.MODEL)) loader = new OBJLoader();
    if(/\.(gltf|glb)$/i.test(_obj.MODEL)) loader = new GLTFLoader();
    if(/\.fbx$/i.test(_obj.MODEL)) loader = new FBXLoader();
    if(loader){
        const prom = new Promise(res=>{
            loader.load(_obj.MODEL,obj=>{
                if(_obj.LINKED[0]){
                    const linked = _obj.LINKED[0];
                    const MODEL = linked.MODEL;
                    let loaderOpt = null;
                    if(/\.obj$/i.test(MODEL)) loaderOpt = new OBJLoader();
                    if(/\.(gltf|glb)$/i.test(MODEL)) loaderOpt = new GLTFLoader();
                    if(/\.fbx$/i.test(MODEL)) loaderOpt = new FBXLoader();
                    // console.log('obj',obj)
                    // console.log('linked',linked)
                    // console.log('MODEL',MODEL)

                    loaderOpt.load(MODEL,option=>{
                        // console.log('option',option)
                        let glb = false
                        if (/\.(gltf|glb)$/i.test(MODEL)) {
                            option = option.scene
                            glb = true
                        }

                        let z=0,x_min=0,x_max=0,zo=0,x_mino=0,x_maxo=0;
                        obj.traverse(mesh=>{
                            if(mesh.isMesh){
                                mesh.geometry.computeBoundingBox();
                                if(mesh.geometry.boundingBox.max.z>z) z=mesh.geometry.boundingBox.max.z;
                                if(mesh.geometry.boundingBox.max.x>x_max) x_max = mesh.geometry.boundingBox.max.x;
                                if(mesh.geometry.boundingBox.min.x<x_min) x_min = mesh.geometry.boundingBox.min.x;

                                // console.log('mesh.material',mesh.material)
                                //
                                // if (mesh.material.length>0) {
                                //     mesh.material.map((_m,i)=>{
                                //         if(_m.name ==='metal' || _m.name ==='metall_stul'){
                                //             mesh.material[i] = window.materials.metal[0]
                                //         }
                                //     })
                                // } else if (mesh.material.name === 'metal' || mesh.material.name ==='metall_stul') {
                                //     mesh.material = window.materials.metal[0]
                                // }
                            }
                        })
                        if (!glb) {
                            option.traverse(mesh=>{
                                if(mesh.isMesh){
                                    mesh.geometry.computeBoundingBox();
                                    if(mesh.geometry.boundingBox.min.z<zo) zo=mesh.geometry.boundingBox.min.z;
                                    if(mesh.geometry.boundingBox.max.x>x_maxo) x_maxo = mesh.geometry.boundingBox.max.x;
                                    if(mesh.geometry.boundingBox.min.x<x_mino) x_mino = mesh.geometry.boundingBox.min.x;
                                }
                            })
                        }
                        const g = new THREE.Group();
                        g.add(option);
                        // console.log('translate', (x_min+x_max)/2,(x_mino+x_maxo)/2);
                        if (!glb) {
                            option.translateX((x_min+x_max+x_mino+x_maxo)/2);
                            option.translateZ(z-zo);
                        }
                        g.userData.type = 'OPTION';
                        g.visible = false;
                        // g.visible = true;
                        obj.add(g);
                        res(obj);
                    });
                }
                else {
                    // console.log('obj',obj)
                    if (/\.(gltf|glb)$/i.test(_obj.MODEL)) {
                        obj = obj.scene;
                    }
                    obj.traverse(mesh=>{
                        if(mesh.isMesh){

                            // console.log('mesh.material',mesh.material)

                            if (mesh.material.length>0) {
                                mesh.material.map((_m,i)=>{
                                    if(_m.name ==='metal' || _m.name ==='metall_stul'){
                                        mesh.material[i] = window.materials.metal[0]
                                    }
                                })
                            } else if (mesh.material.name === 'metal' || mesh.material.name ==='metall_stul') {
                                mesh.material = window.materials.metal[0]
                            }
                        }
                    })
                    res(obj);
                }
            })
        });
        const obj = await prom;
        /*if(_obj.AOMAP && _obj.AOMAP !== null){
            await new Promise(res=> {
                new THREE.TextureLoader()
                    .load(_obj.AOMAP, t => {
                        obj.userData.AOMAP = t;
                        obj.traverse(ob => {
                            if (ob.isMesh) {
                                if (ob.material.length >= 0) {
                                    ob.material.map(m => {
                                        m.aoMap = t;
                                        m.needsUpdate = true;
                                    });
                                } else {
                                    ob.material.aoMap = t;
                                    ob.material.needsUpdate = true;
                                }
                            }
                        });
                    });
                res();
            });
        }*/

        const group = new THREE.Group();
        //const group2 = new THREE.Group();
        group.userData.type = 'MODUL';
        group.add(obj);
        group.userData.animations = obj.animations;
        return new Module(group,_obj)
    }
    else {
        const group = new THREE.Group();
        group.add(new THREE.Group());
        return new Module(group,_obj);
    }
}

async function getModules(){
    const response = await fetch('/ajax/configurator3d.php', {
        method: 'POST',
        body: JSON.stringify({method:"getSleepingModules"}),
        headers: {
            'Content-Type': 'application/json',
            'application':'x-www-form-urlencoded'
        }
    });
    return await response.json();
}

async function getTranslations(){
    const result = await fetch('/configurators/translations.php', {
        method: 'POST',
        body: JSON.stringify({method:"getTranslations"}),
        headers: {
            'Content-Type': 'application/json',
            'application':'x-www-form-urlencoded'
        }
    });
    const res = await result.json();
    return res;
}

async function getMaterials(){
    const result = await fetch('/ajax/configurator3d.php', {
        method: 'POST',
        body: JSON.stringify({method:"getMaterials"}),
        headers: {
            'Content-Type': 'application/json',
            'application':'x-www-form-urlencoded'
        }
    });
    const materialsObj = await result.json();
    const matsAllProm = [];
    const matsKeys = [];

    const textureLoader1 = new THREE.TextureLoader();
    const textureEquirec1 = textureLoader1.load("assets/lythwood_lounge.jpg" );
    textureEquirec1.mapping = THREE.EquirectangularReflectionMapping;
    textureEquirec1.magFilter = THREE.LinearFilter;
    textureEquirec1.minFilter = THREE.LinearMipMapLinearFilter;
    textureEquirec1.encoding = THREE.sRGBEncoding;
    textureEquirec1.anisotropy = 16;

    for(const materialType in materialsObj){
        const materials = materialsObj[materialType];
        const mats = [];
        const matsProm = [];

        materials.map(m=>{
            const matProm = new Promise(resolve=>{
                const material = new THREE.MeshPhongMaterial(materialType==='floor'?{side:THREE.DoubleSide}:{});
                material.perPixel = true;
                material.userData.ID = parseInt(m.ID);
                material.userData.IMAGE = m.IMAGE;
                material.userData.ICON = m.ICON;
                material.userData.PICT = m.PICT;
                material.userData.NAME = m.NAME;
                material.userData.DARK = m.DARK;
                material.name = materialType;
                material.shininess = m.SHININESS;
                // console.log('m.SHININESS',m.SHININESS)
                // console.log('materialType',materialType)
                // material.shininess = 30;
                if(/^[0-9a-fA-F]{6}$/.test(m.DIFFUSECOLOR)){
                    material.color = new THREE.Color(parseInt("0x"+m.DIFFUSECOLOR));
                }
                if(/^[0-9a-fA-F]{6}$/.test(m.SPECULAR)){
                    material.specular = new THREE.Color(parseInt("0x"+m.SPECULAR));
                }

                if (material.name === 'face') {
                    material.shininess = 50;
                    // material.color = new THREE.Color( 0xffffff );
                    // material.specular = new THREE.Color( 0xffffff );
                    material.envMap = textureEquirec1;
                    material.reflectivity = .05;
                    // material.combine = THREE.MixOperation;
                    material.flatShading = true;
                } else if (material.name === 'corp') {
                    // material.shininess = 30;
                    // material.color = new THREE.Color( 0xffffff );
                    // material.specular = new THREE.Color( 0xffffff );
                    material.envMap = textureEquirec1;
                    material.reflectivity = .03;
                    material.flatShading = true;
                } else if (material.name === 'wall') {
                    // material.shininess = 10;
                    // material.color = new THREE.Color( 0xaaaaaa );
                    // material.specular = new THREE.Color( 0x000000 );
                    material.flatShading = true;
                    // material.envMap = textureEquirec1;
                    // material.reflectivity = 0;
                }
                material.castShadow = true;
                material.receiveShadow = true;


                if (materialType==='floor') {
                    material.shininess = 100;
                    material.reflectivity = 1;
                    material.flatShading = true;
                }


                const maps = [];
                if (m.TEXTURE_MAP) {
                    const textProm = new Promise(resolve=>{
                        new THREE.TextureLoader()
                            .load(m.TEXTURE_MAP, (t) => {
                                // t.wrapS = THREE.RepeatWrapping;
                                // t.wrapT = THREE.RepeatWrapping;

                                t.wrapS = t.wrapT = THREE.RepeatWrapping;
                                t.encoding = THREE.sRGBEncoding;
                                t.anisotropy = 16;
                                resolve(t)
                            });
                    });
                    maps.push(textProm);
                }
                else maps.push(new Promise(resolve=>{resolve(null)}));

                if (m.NORMAL_MAP) {
                    const normProm = new Promise(resolve=>{
                        new THREE.TextureLoader()
                            .load(m.NORMAL_MAP, (t) => {
                                // t.wrapS = THREE.RepeatWrapping;
                                // t.wrapT = THREE.RepeatWrapping;

                                t.wrapS = t.wrapT = THREE.RepeatWrapping;
                                t.encoding = THREE.sRGBEncoding;
                                t.anisotropy = 16;
                                resolve(t)
                            });
                    });
                    maps.push(normProm);
                }
                else maps.push(new Promise(resolve=>{resolve(null)}));


                Promise.all(maps)
                    .then(t=>{
                        if(t[0]!==null) material.map = t[0];
                        if(t[1]!==null) material.normalMap = t[1];
                        resolve(material);
                    })

            });
            //matsProm.push(matProm);
            matsProm.push(matProm);
        });
        matsKeys.push(materialType);
        matsAllProm.push(Promise.all(matsProm));
    }
    const t_materials = await Promise.all(matsAllProm);
    const res = {};
    t_materials.map((m,i)=>{
        res[matsKeys[i]] = m;
    });



    const textureLoader = new THREE.TextureLoader();
    const textureEquirec = textureLoader.load("assets/Bright-roof-multi-1024x512.jpg" );
    textureEquirec.mapping = THREE.EquirectangularReflectionMapping;
    textureEquirec.magFilter = THREE.LinearFilter;
    textureEquirec.minFilter = THREE.LinearMipMapLinearFilter;
    textureEquirec.encoding = THREE.sRGBEncoding;
    var chrome = new THREE.MeshLambertMaterial( { envMap: textureEquirec } );
    chrome.name = 'metal'

    res.metal = [chrome]
    // console.log('res',res)
    return res;
}

export default dataSagaAsinc;
